$(function(){
  setTimeout(function(){
    $(".js-notification").fadeOut();
  }, 7000);

  $('.js-notification-close, .notification').on('click',function(){
    $(".js-notification").fadeOut();
  });
});